module.exports = __webpack_public_path__ + "static/media/lock-finish.aa8ab5b0.svg";